module.exports = __webpack_public_path__ + "img/mapp@3x.87a9e3aa.png";